require('angular').module('wowApp.shop')
    .component('wowDynamicSuburbDialog', require('./dynamicsuburb-dialog.component'))
    .component('wowDynamicSuburbDialogContent', require('./dynamicsuburb-dialog-content.component'));



// WEBPACK FOOTER //
// ./src/shop/dynamicsuburb/index.js